import React from 'react';
import { Grid, Paper, Typography, Tooltip } from '@mui/material';
import { INK } from '../../utils/commercialColors';

// Plain stat tiles, not a chart - per the dataviz method, a single number
// is often not a chart's job. Values stay in ink colors (never a series
// color on the text itself); the top accent bar is the only place color
// carries identity, purely decorative.
function StatTile({ label, value, accent, hint }) {
  return (
    <Grid size={{ xs: 6, md: 4, lg: 2 }}>
      <Tooltip title={hint || ''} disableHoverListener={!hint}>
        <Paper
          elevation={1}
          sx={{
            p: 2,
            borderTop: `3px solid ${accent || INK.muted}`,
            height: '100%',
          }}
        >
          <Typography variant="caption" sx={{ color: INK.muted, textTransform: 'uppercase', letterSpacing: 0.5 }}>
            {label}
          </Typography>
          <Typography variant="h5" sx={{ color: INK.primary, fontVariantNumeric: 'tabular-nums', mt: 0.5 }}>
            {value}
          </Typography>
        </Paper>
      </Tooltip>
    </Grid>
  );
}

export default function CommercialKPIs({ overview }) {
  if (!overview) return null;

  const {
    payants_actifs, mrr_total, nouveaux_ce_mois,
    essais_en_cours, conversion_pct, churn_pct, scope_note,
  } = overview;

  return (
    <Grid container spacing={2}>
      <StatTile label="Payants actifs" value={payants_actifs} accent="#2a78d6" />
      <StatTile label="MRR" value={`${Number(mrr_total).toLocaleString('fr-FR')} €`} accent="#2a78d6" />
      <StatTile
        label="Nouveaux ce mois"
        value={`+${nouveaux_ce_mois}`}
        accent="#0ca30c"
        hint={scope_note}
      />
      <StatTile label="Essais en cours" value={essais_en_cours} accent="#2a78d6" />
      <StatTile
        label="Conversion"
        value={`${conversion_pct}%`}
        accent="#0ca30c"
        hint={scope_note}
      />
      <StatTile
        label="Churn"
        value={`${churn_pct}%`}
        accent="#d03b3b"
        hint={scope_note}
      />
    </Grid>
  );
}
